import Vue from 'vue';
import $ from 'jquery';
import 'popper.js';
import 'bootstrap';

// https://medium.com/js-dojo/creating-custom-directives-in-vue-js-286142392fd8
export default function() {
    // Register a global custom directive called `v-visible`
    // Example use: v-visible="bool"
    Vue.directive('visible', function(el, binding) {
        if (binding.value === true) {
            el.style.visibility = 'hidden';
        } else {
            el.style.visibility = 'visible';
        }
    });

    Vue.directive('tooltip', function(el, binding) {
        $(el).tooltip({
            title: binding.value,
            placement: binding.arg,
            trigger: 'hover'
        });
    });
}
